module.exports = __webpack_public_path__ + "static/media/Instagram.26b65b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/Instagram.png
// module id = 386
// module chunks = 0